import type { SCategory } from "@/queries/faq/faq.api";
import type { ApiFaqlResponseType } from "@/types/entities/faq";

export interface Question {
  id: string;
  question: string;
  answer: string;
  category: string;
}

export interface Section {
  section: string;
  questions: Question[];
}

export interface InputQuestion {
  id: string;
  category: string;
  status: string;
  order: number;
  question: string;
  response: string;
}

export interface Category {
  id: string;
  name: string;
  created_at: string;
  updated_at: string;
  order: number;
}

export const QuestionManager = (
  faqsRaw?: InputQuestion[] | ApiFaqlResponseType,
  catsRaw?:
    | Category[]
    | {
        data: SCategory[];
      },
): Section[] => {
  const faqsList: InputQuestion[] = Array.isArray(faqsRaw)
    ? faqsRaw
    : Array.isArray((faqsRaw as ApiFaqlResponseType)?.data)
      ? ((faqsRaw as ApiFaqlResponseType).data as unknown as InputQuestion[])
      : [];

  const catsList: Category[] = Array.isArray(catsRaw)
    ? catsRaw
    : Array.isArray((catsRaw as { data: SCategory[] })?.data)
      ? (catsRaw as { data: SCategory[] }).data
      : [];

  if (catsList.length === 0) {
    if (faqsList.length === 0) {
      return [{ section: "General", questions: [] }];
    }

    const sorted = faqsList.slice().sort((a, b) => a.order - b.order);
    const sectionsMap: Record<string, Question[]> = {};
    sorted.forEach(({ id, category, question, response }) => {
      const q: Question = { id, question, category, answer: `${response}` };
      if (!sectionsMap[category]) sectionsMap[category] = [];
      sectionsMap[category].push(q);
    });

    return Object.entries(sectionsMap).map(([section, questions]) => ({
      section,
      questions,
    }));
  }

  return catsList
    .slice()
    .sort((a, b) => a.order - b.order)
    .map((cat) => {
      const questions: Question[] = faqsList
        .filter((f) => f.category === cat.name)
        .sort((a, b) => a.order - b.order)
        .map(({ id, question, category, response }) => ({
          id,
          question,
          category,
          answer: `${response}`,
        }));
      return { section: cat.name, questions };
    });
};
